import clsx from 'clsx';
import Icon from 'components/atoms/Icon';
import React from 'react';
import styles from './AccordionButton.module.scss';

type AccordionButtonProps = {
  isOpen: boolean;
  title: string;
  className?: string;
  isDisabled?: boolean;
  dataTestId?: string;
  children?: React.ReactNode;
  onClick: () => void;
};
export const AccordionButton = ({
  isOpen,
  title,
  className,
  isDisabled,
  dataTestId,
  children,
  onClick,
}: AccordionButtonProps) => {
  return (
    <button
      className={clsx(
        className,
        styles.accordionButton,
        isDisabled && styles.disabled
      )}
      onClick={() => !isDisabled && onClick()}
      data-testid={dataTestId}
      tabIndex={isDisabled ? -1 : 0}
    >
      <div className={styles.accordionButtonTitle}>
        <Icon
          icon="arrow_down_accordion"
          className={clsx(
            isOpen && styles.expanded,
            isDisabled && styles.hidden,
            styles.arrowDown
          )}
        />
        <h4>{title}</h4>
      </div>
      {children}
    </button>
  );
};
